const locale = require('./changeAgency.i18n.json');

/*@ngInject*/
const ChangeAgencyModalController = function ($rootScope, $scope, coreConstant, coreMediator, loadingBarHandler, submissionMediator, options) {
    $scope.i18n = locale;

    $scope.viewModel = {
        title: options.title ? options.title : _.get( $scope.i18n, 'title'),
        cancelButton: options.cancelButtonLabel ? options.cancelButtonLabel : _.get( $scope.i18n, 'cancel'),
        okButton: options.confirmActionButtonLabel ? options.confirmActionButtonLabel : _.get( $scope.i18n, 'confirm'),
        loadingBar: options.processingIndicatorText ? options.processingIndicatorText : _.get( $scope.i18n, 'loadingBar'),
        agencyList: [],
        originalAgencyId: String(submissionMediator.getCurrentSubmission().agencyId)
    };

    $scope.dataSetParameters = {
        name: _.get( $scope.i18n, 'agencyDataSetName')
    }

    $scope.onConfirm = () => {
        let submissionUpdatePropertiesMap = {
            agencyId: $scope.viewModel.selectedAgency.value
        }

        loadingBarHandler.showLoadingBar($scope.viewModel.loadingBar);
        submissionMediator.updateSubmission(submissionMediator.getCurrentSubmission().id, submissionUpdatePropertiesMap).then(function () {
            loadingBarHandler.hideLoadingBar();
        });

        $scope.$close();
    };

    $scope.onCancel = () => {
        $scope.$dismiss();
    };

    $scope.onSelectAgency = (selectedAgency) => {
        $scope.viewModel.selectedAgency = selectedAgency;
    };

    $scope.canEnableConfirmButton = function () {
        return $scope.showCheckMarkForAgencyDropDown();
    };

    $scope.showCheckMarkForAgencyDropDown = function () {
        return isValidAgencySelected();
    };

    function isValidAgencySelected() {
        return !!$scope.viewModel.selectedAgency && $scope.viewModel.selectedAgency.value !== $scope.viewModel.originalAgencyId;
    }

    coreMediator.getDynamicDataSetItems($scope.dataSetParameters).then(function (result) {
        $scope.viewModel.agencyList = result;
        initializeAgency();
    });

    function initializeAgency() {
        _.forEach($scope.viewModel.agencyList, function (agency) {
            if (agency.value === $scope.viewModel.originalAgencyId) {
                $scope.viewModel.selectedAgency = agency;
                return false;
            }
        });
    }

    $scope.getAgencyLabel = function () {
        const selectedAgency = $scope.viewModel.selectedAgency;
        return selectedAgency ? selectedAgency.name : _.get( $scope.i18n, 'defaultPrimaryPrompt');
    };

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};

angular.module('gw-um-submission')
    .controller('changeAgencyModalController', ChangeAgencyModalController);
